export default "__VITE_ASSET__gI$hOolzRoMGP6j5JCUYkA__";